import { render, staticRenderFns } from "./BaseTopMenu.vue?vue&type=template&id=9626ee8c&scoped=true&"
import script from "./BaseTopMenu.vue?vue&type=script&lang=js&"
export * from "./BaseTopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9626ee8c",
  null
  
)

export default component.exports